module.exports = __webpack_public_path__ + "static/media/TrashCanIcon.44e6c17e.svg";